// How the feature writes an amount of money (components/Money.tsx sets it
// in the financial font).

import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { formatCurrency } from "@rentiohq/shared-frontend/dist/utils/number.utils";
import { roundCents } from "./money.utils";

// The minus of a negative amount: the feature's own "− € 30,58" (as the
// provisions' "− € 960,00"), never formatCurrency's "€ -30,58" (M29, retest
// of 2026-10-20). A non-breaking space keeps it with the amount.
const MINUS = "− ";

// Rentio-consistent currency formatting (e.g. "€ 1.997,26"), with a
// non-breaking space so a narrow column never leaves the "€" on its own line.
// Always to the cent: formatCurrency prints every decimal it is given, so a
// sum like 4188.480000000001 showed as such. `|| 0` keeps -0 from printing as
// "€ -0,00", and a negative amount reads "− € 30,58".
export const formatMoney = (amount: number): string => {
  const rounded = roundCents(amount) || 0;
  const text = formatCurrency(Math.abs(rounded)).replace(/ /g, " ");
  return rounded < 0 ? `${MINUS}${text}` : text;
};

// The VAT under an amount: "+ € 21,00 btw", and for a credit "− € 0,53 btw".
export const vatLineText = (vat: number): string =>
  (roundCents(vat) || 0) < 0
    ? getLocalizedText("costs.detail.minus_vat", { amount: formatMoney(-vat) })
    : getLocalizedText("costs.detail.plus_vat", { amount: formatMoney(vat) });
